import { render, staticRenderFns } from "./MainLedgerDetailList.vue?vue&type=template&id=57fe5532&scoped=true"
import script from "./MainLedgerDetailList.vue?vue&type=script&lang=js"
export * from "./MainLedgerDetailList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fe5532",
  null
  
)

export default component.exports